import type { GetProjectById200AuthContext } from './getProjectById200AuthContext';
import type { GetProjectById200BasicInfo } from './getProjectById200BasicInfo';
import type { GetProjectById200FileInfo } from './getProjectById200FileInfo';
import type { GetProjectById200MetaInfo } from './getProjectById200MetaInfo';
import type { GetProjectById200StatsInfo } from './getProjectById200StatsInfo';
import type { GetProjectById200UserInfo } from './getProjectById200UserInfo';
import type { GetProjectById200UserInteraction } from './getProjectById200UserInteraction';

/**
 * 구조화된 단일 프로젝트 응답 데이터
 */
export type GetProjectById200 = {
  /** 인증 컨텍스트 정보 */
  authContext?: GetProjectById200AuthContext;
  /** 프로젝트 기본 정보 */
  basicInfo?: GetProjectById200BasicInfo;
  /** 프로젝트 파일 정보 */
  fileInfo?: GetProjectById200FileInfo;
  /** 프로젝트 메타 정보 */
  metaInfo?: GetProjectById200MetaInfo;
  /** 프로젝트 통계 정보 */
  statsInfo?: GetProjectById200StatsInfo;
  /** 간략한 사용자 정보 */
  userInfo?: GetProjectById200UserInfo;
  /** 현재 사용자와 프로젝트 간의 상호작용 정보 */
  userInteraction?: GetProjectById200UserInteraction;
};
